export default __webpack_public_path__ + "static/seguridad-movilidad-0a3d67d58ff4f6bdb9f5726920f64572.png";